import { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { RealmProvider } from "@/contexts/RealmContext";
import { UserProvider } from "@/contexts/UserContext";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <ThemeProvider>
        <RealmProvider>
          <UserProvider>{children}</UserProvider>
        </RealmProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
